// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-hero[data-v-9c582e10]{background:url(/images/about-us/crew-hero.jpeg) 50% 50% no-repeat transparent;background-size:cover}.overlay[data-v-9c582e10]{background-color:rgba(0,0,0,.35);bottom:0;left:0;position:absolute;right:0;top:0}.photographer-credit[data-v-9c582e10]{bottom:12px;position:absolute;right:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
